module.exports = __webpack_public_path__ + "img/ts21.498d03c8.png";